import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { loadMarketingGoogleAdsIfAllowed } from '../../utils/marketingGoogleAds'
import { loadMetaPixelIfAllowed } from '../../utils/metaPixel'
import { captureMetaClickId } from '../../utils/metaClickId'
import { captureFirstTouch } from '../../utils/firstTouch'

/** Loads Google Ads gtag and the Meta Pixel on public marketing routes after marketing cookie consent. */
export function MarketingGoogleAdsTracker() {
  const { pathname } = useLocation()

  // First-party attribution, whatever the cookie consent. Runs on every route change
  // so a first load on a signed-in route doesn't forfeit the next public landing;
  // the store itself is write-once.
  useEffect(() => {
    captureFirstTouch(window.location, document.referrer)
  }, [pathname])

  useEffect(() => {
    captureMetaClickId()
    loadMarketingGoogleAdsIfAllowed(pathname)
    loadMetaPixelIfAllowed(pathname)
  }, [pathname])

  useEffect(() => {
    const onConsent = () => {
      loadMarketingGoogleAdsIfAllowed(window.location.pathname)
      loadMetaPixelIfAllowed(window.location.pathname)
    }
    window.addEventListener('cookie-consent-updated', onConsent)
    return () => window.removeEventListener('cookie-consent-updated', onConsent)
  }, [])

  return null
}

export default MarketingGoogleAdsTracker
